import React from 'react';
import { Tooltip } from '@mui/material';
import ToolTipContent from '../toolTipContent';
import Ito from './ito';

const ItoWrapper = (props) => {
   if (props.dayStatus && props.dayStatus.bookings !== null) {
      return (
         <Tooltip
            title={<ToolTipContent dayStatus={props.dayStatus} />}
            placement="top"
            arrow
         >
            <div>
               <Ito
                  clickable={props.clickable}
                  styles={props.styles}
                  miniChips={props.miniChips}
                  bookings={true}
                  data={props.data}
                  setSpaceData={props.setSpaceData}
                  setStatusDrawerOpen={props.setStatusDrawerOpen}
               />
            </div>
         </Tooltip>
      );
   } else if (
      props.dayStatus &&
      props.dayStatus.bookings === null &&
      props.dayStatus.times
   ) {
      return (
         <Tooltip
            title={<ToolTipContent dayStatus={props.dayStatus} />}
            placement="top"
            arrow
         >
            <div>
               <Ito
                  clickable={props.clickable}
                  styles={props.styles}
                  miniChips={props.miniChips}
                  bookings={false}
                  data={props.data}
                  setSpaceData={props.setSpaceData}
                  setStatusDrawerOpen={props.setStatusDrawerOpen}
               />
            </div>
         </Tooltip>
      );
   } else {
      return (
         <Ito
            clickable={props.clickable}
            styles={props.styles}
            miniChips={props.miniChips}
            bookings={false}
            data={props.data}
            setSpaceData={props.setSpaceData}
            setStatusDrawerOpen={props.setStatusDrawerOpen}
         />
      );
   }
};
export default ItoWrapper;
